var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3992 17.4755L13.3992 4.3C13.3992 3.85817 13.7574 3.5 14.1992 3.5C14.6411 3.5 14.9992 3.85817 14.9992 4.3V17.1001L19.6752 12.7128C19.993 12.4146 20.491 12.4319 20.7875 12.7513C21.0841 13.0708 21.0669 13.5714 20.7492 13.8695L14.5362 19.699C14.2338 19.9827 13.7646 19.9827 13.4622 19.699L7.24922 13.8695C6.93147 13.5714 6.9143 13.0708 7.21086 12.7513C7.50743 12.4319 8.00542 12.4146 8.32316 12.7128L13.3992 17.4755ZM3.99922 19.7C4.44105 19.7 4.79922 20.0581 4.79922 20.5V24.5C4.79922 24.6104 4.88876 24.7 4.99922 24.7H22.9992C23.1097 24.7 23.1992 24.6104 23.1992 24.5V20.5C23.1992 20.0581 23.5574 19.7 23.9992 19.7C24.441 19.7 24.7992 20.0581 24.7992 20.5V24.5C24.7992 25.4941 23.9933 26.3 22.9992 26.3H4.99922C4.00511 26.3 3.19922 25.4941 3.19922 24.5V20.5C3.19922 20.0581 3.55739 19.7 3.99922 19.7Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinDownloadIcon);
export default __webpack_public_path__ + "static/media/zeppelin-download-icon.a2791150.svg";
export { ForwardRef as ReactComponent };